// Nested reducers
import { reviewQuotesReducer } from "./review-quotes/review-quotes.reducer";

// **************************************************************************
// CENTRAL SUPPORT REDUCER
// **************************************************************************

export const centralSupportReducer = [
    // Spread nested reducers
    ...reviewQuotesReducer,
];
